import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AccountingAccount } from "../../../../../data/entities";
import { api } from "../../../../../shared/hooks/api";
import { error, success } from "../../../../../utils/toast";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface ActionMenuProps {
    account: AccountingAccount;
    onRefresh?: () => void;
    isParent?: boolean;
}

const ActionMenu = ({ account, onRefresh, isParent }: ActionMenuProps) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [{ isLoading: isUpdating }, updateAccount] = api.patch(
        `/accounting/accounts/${account.id}/update/`
    );
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        handleClose();
        navigate(`/accounting-accounts/${account.id}`);
    };

    const handleClone = () => {
        handleClose();
        navigate("/accounting-accounts/create", {
            state: { cloneData: account },
        });
    };

    const handleToggleStatus = async () => {
        handleClose();
        const newStatus = account.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";

        try {
            await updateAccount({
                status: newStatus,
            });
            success(
                "Thành Công",
                `${newStatus === "ACTIVE" ? "Kích hoạt" : "Vô hiệu hóa"} tài khoản thành công`
            );
            onRefresh?.();
        } catch (err) {
            error("Lỗi cập nhật trạng thái", err);
        }
    };

    const [{ isLoading: isDeleting }, deleteAccount] = api.delete(
        `/accounting/accounts/${account.id}/delete/`
    );

    const handleDelete = async () => {
        handleClose();
        try {
            await deleteAccount();
            success("THÀNH CÔNG", "Xóa tài khoản kế toán thành công");
            onRefresh?.();
        } catch (err) {
            error("Lỗi xóa tài khoản kế toán", err);
        }
    };

    const isActive = account.status === "ACTIVE";

    return (
        <>
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                size="small"
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <MenuItem onClick={handleEdit}>Chỉnh sửa</MenuItem>
                <MenuItem onClick={handleClone}>Sao chép</MenuItem>
                <MenuItem onClick={handleToggleStatus} disabled={isUpdating}>
                    {isActive ? "Vô hiệu hóa" : "Kích hoạt"}
                </MenuItem>
                <MenuItem onClick={handleDelete} disabled={isDeleting}>
                        Xóa
                </MenuItem>
                
            </Menu>
        </>
    );
};

export default ActionMenu;
